const isDashboardItemSelected = (state = false, action) => {
  switch (action.type) {
    case 'SET_IS_DASHBOARD_ITEM_SELECTED':
      return action.payload;
    default:
      return state;
  }
};

export default isDashboardItemSelected;
